<template>
  <div>
    <div class="t-progress">
      <div
        :class="!indeterminate ? 't-progress-bar' : 't-indeterminate'"
        :style="barStyles"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 't-progress',
  props: {
    color: { type: String, default: 'bluegray-80' },
    steps: { type: Number, default: 60, required: false },
    count: { type: Number, default: 30, required: false },
    start: { type: Number, default: 0 },
    indeterminate: { type: Boolean, default: false },
  },
  computed: {
    barStyles() {
      let width = 0;
      if (this.count || this.steps) {
        width = (this.count * 100) / this.steps;
      }
      return {
        backgroundColor: `var(--track-color-${this.color})`,
        width: `${width}%`,
        marginLeft: `${(this.start * 100) / this.steps}%`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.t-progress,
.t-progress-bar {
  background-color: var(--track-color-bluegray-20);
  border-radius: 20px;
  height: var(--track-spacing-sm);
}

.t-indeterminate {
  max-width: 50%;
  border-radius: 20px;
  height: var(--track-spacing-sm);
  animation: go-back 2s infinite alternate;
}

@keyframes go-back {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
